// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import "./Ecomcart.css";
// import { MdDeleteForever } from "react-icons/md";
// const EcomCart = () => {
//   const navigate = useNavigate();
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [updatingItem, setUpdatingItem] = useState(null);
//   const [cartSummary, setCartSummary] = useState({
//     total_items: 0,
//     total_price: 0,
//   });

//   // Temporary quantity state for each item
//   const [tempQuantities, setTempQuantities] = useState({});

//   useEffect(() => {
//     const token = localStorage.getItem("accessToken");
//     if (!token) {
//       navigate("/AuthForm");
//       return;
//     }
//     fetchCartItems();
//   }, [navigate]);

//   const fetchCartItems = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem("accessToken");
//       if (!token) {
//         navigate("/AuthForm");
//         return;
//       }

//       const response = await fetch(
//         "https://vogelkoparchitects.com/api/ecom/cart/list-cart/",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("userId");
//         localStorage.removeItem("username");
//         setError("Your session has expired. Please login again.");
//         setTimeout(() => navigate("/AuthForm"), 2000);
//         return;
//       }

//       if (!response.ok) throw new Error("Failed to fetch cart items");

//       const data = await response.json();
//       processCartData(data);
//     } catch (err) {
//       console.error("Error fetching cart:", err);
//       setError("Failed to load cart items. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const processCartData = (data) => {
//     setCartItems(data.items || []);
//     setCartSummary({
//       total_items: data.total_items || 0,
//       total_price: data.total_price || 0,
//     });

//     // Initialize temp quantities
//     const initialQuantities = {};
//     data.items.forEach((item) => {
//       initialQuantities[item.cart_item_id] = item.quantity;
//     });
//     setTempQuantities(initialQuantities);
//   };

//   // Handle quantity change in UI
//   const handleQuantityChange = (itemId, newQuantity) => {
//     if (newQuantity < 1) return;
//     setTempQuantities((prev) => ({
//       ...prev,
//       [itemId]: newQuantity,
//     }));
//   };

//   // Show update confirmation
//   const showUpdateConfirmation = (item, newQuantity) => {
//     if (newQuantity === item.quantity) return; // No change needed

//     Swal.fire({
//       title: "Update Quantity?",
//       text: `Do you want to change quantity from ${item.quantity} to ${newQuantity}?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonColor: "#28a745",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: "Yes, update it!",
//       cancelButtonText: "Cancel",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         updateQuantity(item, newQuantity);
//       } else {
//         // Revert temp quantity
//         setTempQuantities((prev) => ({
//           ...prev,
//           [item.cart_item_id]: item.quantity,
//         }));
//       }
//     });
//   };

//   // Update quantity API call
//   const updateQuantity = async (item, newQuantity) => {
//     setUpdatingItem(item.cart_item_id);
//     setError(null);

//     try {
//       const token = localStorage.getItem("accessToken");

//       // Try PUT method first (based on 405 error, PUT might work)
//       const response = await fetch(
//         `https://vogelkoparchitects.com/api/ecom/cart-update/${item.cart_item_id}/`,
//         {
//           method: "PUT", // Changed from POST to PUT
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             quantity: newQuantity,
//           }),
//         },
//       );

//       if (response.status === 405) {
//         // If PUT fails, try PATCH
//         const patchResponse = await fetch(
//           `https://vogelkoparchitects.com/api/ecom/cart-update/${item.cart_item_id}/`,
//           {
//             method: "PATCH",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               quantity: newQuantity,
//             }),
//           },
//         );

//         if (!patchResponse.ok) {
//           throw new Error("Update failed");
//         }
//       } else if (!response.ok) {
//         throw new Error("Failed to update quantity");
//       }

//       // Show success message
//       Swal.fire({
//         title: "Updated!",
//         text: "Cart quantity has been updated.",
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       // Refresh cart items
//       await fetchCartItems();
//     } catch (err) {
//       console.error("Error updating quantity:", err);
//       setError("Failed to update quantity. Please try again.");

//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update quantity. Please try again.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });

//       // Revert temp quantity
//       setTempQuantities((prev) => ({
//         ...prev,
//         [item.cart_item_id]: item.quantity,
//       }));
//     } finally {
//       setUpdatingItem(null);
//     }
//   };

//   // Remove item with confirmation
//   const removeItem = async (item) => {
//     const result = await Swal.fire({
//       title: "Remove Item?",
//       text: `Are you sure you want to remove "${item.product_name}" from your cart?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#dc3545",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: "Yes, remove it!",
//       cancelButtonText: "Cancel",
//     });

//     if (!result.isConfirmed) return;

//     setUpdatingItem(item.cart_item_id);
//     setError(null);

//     try {
//       const token = localStorage.getItem("accessToken");

//       const response = await fetch(
//         `https://vogelkoparchitects.com/api/ecom/cart-remove/${item.cart_item_id}/`,
//         {
//           method: "DELETE",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       if (response.status === 405) {
//         // Try alternative method if DELETE fails
//         const altResponse = await fetch(
//           `https://vogelkoparchitects.com/api/ecom/cart-remove/${item.cart_item_id}/`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               action: "remove",
//             }),
//           },
//         );

//         if (!altResponse.ok) {
//           throw new Error("Remove failed");
//         }
//       } else if (!response.ok) {
//         throw new Error("Failed to remove item");
//       }

//       // Show success message
//       Swal.fire({
//         title: "Removed!",
//         text: "Item has been removed from your cart.",
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       await fetchCartItems();
//     } catch (err) {
//       console.error("Error removing item:", err);
//       setError("Failed to remove item. Please try again.");

//       Swal.fire({
//         title: "Error!",
//         text: "Failed to remove item. Please try again.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setUpdatingItem(null);
//     }
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   const handleContinueShopping = () => navigate("/products");
//   const handleLogin = () => navigate("/AuthForm");

//   if (loading) {
//     return (
//       <div className="cart-loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your cart...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="cart-banner">
//         <img
//           src="/assets/img/ecommerce/banner/banner1.jpg"
//           alt="Shopping Cart Banner"
//           className="cart-banner-image"
//           onError={(e) => {
//             e.target.src =
//               "https://via.placeholder.com/1200x250?text=Shopping+Cart";
//           }}
//         />
//         <div className="cart-banner-overlay">
//           <div>
//             <h1 className="cart-banner-title">Your Shopping Cart</h1>
//             <p className="cart-banner-subtitle">Review and manage your items</p>
//           </div>
//         </div>
//       </div>

//       <div className="ecom-cart-container">
//         {error && (
//           <div className="cart-error-message">
//             {error}
//             {error.includes("session has expired") ? (
//               <button onClick={handleLogin} className="retry-btn">
//                 Go to Login
//               </button>
//             ) : (
//               <button onClick={fetchCartItems} className="retry-btn">
//                 Retry
//               </button>
//             )}
//           </div>
//         )}

//         {!loading && cartItems.length === 0 && !error ? (
//           <div className="empty-cart">
//             <div className="empty-cart-icon">🛒</div>
//             <h2 className="empty-cart-title">Your cart is empty</h2>
//             <p className="empty-cart-message">
//               Looks like you haven't added any items to your cart yet.
//             </p>
//             <button
//               className="continue-shopping-btn"
//               onClick={handleContinueShopping}
//             >
//               Continue Shopping
//             </button>
//           </div>
//         ) : (
//           cartItems.length > 0 && (
//             <>
//               <div className="cart-items-list">
//                 {cartItems.map((item) => (
//                   <div key={item.cart_item_id} className="cart-item">
//                     <div className="cart-item-image">
//                       <img
//                         src={item.image || "/api/placeholder/200/200"}
//                         alt={item.product_name}
//                         onError={(e) => {
//                           e.target.src = "/api/placeholder/200/200";
//                         }}
//                       />
//                     </div>

//                     <div className="cart-item-details">
//                       <div className="cart-item-header">
//                         <h3 className="cart-item-name">{item.product_name}</h3>
//                         <button
//                           className="cart-item-remove"
//                           onClick={() => removeItem(item)}
//                           disabled={updatingItem === item.cart_item_id}
//                         >
//                           <MdDeleteForever />
//                         </button>
//                       </div>

//                       <div className="cart-item-specs">
//                         {item.category && (
//                           <span className="cart-item-spec">
//                             {item.category}
//                           </span>
//                         )}
//                         {item.size && (
//                           <span className="cart-item-spec">
//                             Size: {item.size}
//                           </span>
//                         )}
//                         {item.wood_type && (
//                           <span className="cart-item-spec">
//                             Wood: {item.wood_type}
//                           </span>
//                         )}
//                       </div>

//                       <div className="cart-item-footer">
//                         <div className="cart-item-price">
//                           <span className="unit-price">
//                             {formatCurrency(item.unit_price)}
//                           </span>
//                           <span className="total-price">
//                             {formatCurrency(item.total_price)}
//                           </span>
//                         </div>

//                         <div className="cart-item-quantity">
//                           <button
//                             className="quantity-btn"
//                             onClick={() =>
//                               handleQuantityChange(
//                                 item.cart_item_id,
//                                 (tempQuantities[item.cart_item_id] ||
//                                   item.quantity) - 1,
//                               )
//                             }
//                             disabled={
//                               updatingItem === item.cart_item_id ||
//                               (tempQuantities[item.cart_item_id] ||
//                                 item.quantity) <= 1
//                             }
//                           >
//                             −
//                           </button>

//                           <span className="quantity-value">
//                             {tempQuantities[item.cart_item_id] || item.quantity}
//                           </span>

//                           <button
//                             className="quantity-btn"
//                             onClick={() =>
//                               handleQuantityChange(
//                                 item.cart_item_id,
//                                 (tempQuantities[item.cart_item_id] ||
//                                   item.quantity) + 1,
//                               )
//                             }
//                             disabled={updatingItem === item.cart_item_id}
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>

//                       {/* Update Button - Shows only if quantity changed */}
//                       {tempQuantities[item.cart_item_id] !== item.quantity && (
//                         <div className="cart-item-update">
//                           <button
//                             className="update-btn"
//                             onClick={() =>
//                               showUpdateConfirmation(
//                                 item,
//                                 tempQuantities[item.cart_item_id],
//                               )
//                             }
//                             disabled={updatingItem === item.cart_item_id}
//                           >
//                             {updatingItem === item.cart_item_id
//                               ? "Updating..."
//                               : "Update Quantity"}
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               <div className="cart-summary">
//                 <h2 className="summary-title">Order Summary</h2>
//                 <div className="summary-row">
//                   <span>Subtotal ({cartSummary.total_items} items)</span>
//                   <span>{formatCurrency(cartSummary.total_price)}</span>
//                 </div>
//                 <div className="summary-row total">
//                   <span>Total</span>
//                   <span>{formatCurrency(cartSummary.total_price)}</span>
//                 </div>
//                 <button
//                   className="continue-shopping-link"
//                   onClick={handleContinueShopping}
//                 >
//                   ← Continue Shopping
//                 </button>
//               </div>
//             </>
//           )
//         )}
//       </div>
//     </>
//   );
// };

// export default EcomCart;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Ecomcart.css";
import { MdDeleteForever } from "react-icons/md";

const EcomCart = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingItem, setUpdatingItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState({});
  const [cartSummary, setCartSummary] = useState({
    total_items: 0,
    total_price: 0,
  });

  // Temporary quantity state for each item
  const [tempQuantities, setTempQuantities] = useState({});

  const fetchCartItems = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/AuthForm");
        return;
      }

      const response = await fetch(
        "https://vogelkoparchitects.com/api/ecom/cart/list-cart/",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("username");
        setError("Your session has expired. Please login again.");
        setTimeout(() => navigate("/AuthForm"), 2000);
        return;
      }

      if (!response.ok) throw new Error("Failed to fetch cart items");

      const data = await response.json();
      processCartData(data);
    } catch (err) {
      console.error("Error fetching cart:", err);
      setError("Failed to load cart items. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/AuthForm");
      return;
    }
    fetchCartItems();
  }, [navigate, fetchCartItems]);

  const processCartData = (data) => {
    setCartItems(data.items || []);
    setCartSummary({
      total_items: data.total_items || 0,
      total_price: data.total_price || 0,
    });

    // Initialize temp quantities
    const initialQuantities = {};
    // Initialize all items as selected by default
    const initialSelected = {};

    data.items.forEach((item) => {
      initialQuantities[item.cart_item_id] = item.quantity;
      initialSelected[item.cart_item_id] = true; // All items selected by default
    });

    setTempQuantities(initialQuantities);
    setSelectedItems(initialSelected);
  };

  // Handle select/deselect all items
  const handleSelectAll = () => {
    const allSelected = Object.values(selectedItems).every(Boolean);
    const newSelected = {};
    cartItems.forEach((item) => {
      newSelected[item.cart_item_id] = !allSelected;
    });
    setSelectedItems(newSelected);
  };

  // Handle individual item selection
  const handleSelectItem = (itemId) => {
    setSelectedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  // Calculate selected items summary
  const getSelectedSummary = () => {
    let selectedCount = 0;
    let selectedTotal = 0;

    cartItems.forEach((item) => {
      if (selectedItems[item.cart_item_id]) {
        selectedCount += item.quantity;
        selectedTotal += item.total_price;
      }
    });

    return { selectedCount, selectedTotal };
  };

  const { selectedCount, selectedTotal } = getSelectedSummary();
  const allSelected =
    cartItems.length > 0 && Object.values(selectedItems).every(Boolean);
  const someSelected = Object.values(selectedItems).some(Boolean);

  // Handle quantity change in UI
  const handleQuantityChange = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    setTempQuantities((prev) => ({
      ...prev,
      [itemId]: newQuantity,
    }));
  };

  // Show update confirmation
  const showUpdateConfirmation = (item, newQuantity) => {
    if (newQuantity === item.quantity) return;

    Swal.fire({
      title: "Update Quantity?",
      text: `Do you want to change quantity from ${item.quantity} to ${newQuantity}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        updateQuantity(item, newQuantity);
      } else {
        setTempQuantities((prev) => ({
          ...prev,
          [item.cart_item_id]: item.quantity,
        }));
      }
    });
  };

  // Update quantity API call
  const updateQuantity = async (item, newQuantity) => {
    setUpdatingItem(item.cart_item_id);
    setError(null);

    try {
      const token = localStorage.getItem("accessToken");

      const response = await fetch(
        `https://vogelkoparchitects.com/api/ecom/cart-update/${item.cart_item_id}/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            quantity: newQuantity,
          }),
        },
      );

      if (response.status === 405) {
        const patchResponse = await fetch(
          `https://vogelkoparchitects.com/api/ecom/cart-update/${item.cart_item_id}/`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              quantity: newQuantity,
            }),
          },
        );

        if (!patchResponse.ok) {
          throw new Error("Update failed");
        }
      } else if (!response.ok) {
        throw new Error("Failed to update quantity");
      }

      Swal.fire({
        title: "Updated!",
        text: "Cart quantity has been updated.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      await fetchCartItems();
    } catch (err) {
      console.error("Error updating quantity:", err);
      setError("Failed to update quantity. Please try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to update quantity. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });

      setTempQuantities((prev) => ({
        ...prev,
        [item.cart_item_id]: item.quantity,
      }));
    } finally {
      setUpdatingItem(null);
    }
  };

  // Remove item with confirmation
  const removeItem = async (item) => {
    const result = await Swal.fire({
      title: "Remove Item?",
      text: `Are you sure you want to remove "${item.product_name}" from your cart?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, remove it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    setUpdatingItem(item.cart_item_id);
    setError(null);

    try {
      const token = localStorage.getItem("accessToken");

      const response = await fetch(
        `https://vogelkoparchitects.com/api/ecom/cart-remove/${item.cart_item_id}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 405) {
        const altResponse = await fetch(
          `https://vogelkoparchitects.com/api/ecom/cart-remove/${item.cart_item_id}/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              action: "remove",
            }),
          },
        );

        if (!altResponse.ok) {
          throw new Error("Remove failed");
        }
      } else if (!response.ok) {
        throw new Error("Failed to remove item");
      }

      Swal.fire({
        title: "Removed!",
        text: "Item has been removed from your cart.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      await fetchCartItems();
    } catch (err) {
      console.error("Error removing item:", err);
      setError("Failed to remove item. Please try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to remove item. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setUpdatingItem(null);
    }
  };

  // Handle checkout with selected items
  const handleCheckout = () => {
    const selectedProducts = cartItems.filter(
      (item) => selectedItems[item.cart_item_id],
    );

    if (selectedProducts.length === 0) {
      Swal.fire({
        title: "No Items Selected",
        text: "Please select at least one item to proceed with checkout.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    // Navigate to place order page with selected items
    navigate("/place-order", {
      state: {
        selectedItems: selectedProducts,
        totalAmount: selectedTotal,
        itemCount: selectedCount,
      },
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const handleContinueShopping = () => navigate("/products");
  const handleLogin = () => navigate("/AuthForm");

  if (loading) {
    return (
      <div className="cart-loading-container">
        <div className="loading-spinner"></div>
        <p>Loading your cart...</p>
      </div>
    );
  }

  return (
    <>
      <div className="cart-banner">
        <img
          src="/assets/img/ecommerce/banner/banner1.jpg"
          alt="Shopping Cart Banner"
          className="cart-banner-image"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1200x250?text=Shopping+Cart";
          }}
        />
        <div className="cart-banner-overlay">
          <div>
            <h1 className="cart-banner-title">Your Shopping Cart</h1>
            <p className="cart-banner-subtitle">Review and manage your items</p>
          </div>
        </div>
      </div>

      <div className="ecom-cart-container">
        {error && (
          <div className="cart-error-message">
            {error}
            {error.includes("session has expired") ? (
              <button onClick={handleLogin} className="retry-btn">
                Go to Login
              </button>
            ) : (
              <button onClick={fetchCartItems} className="retry-btn">
                Retry
              </button>
            )}
          </div>
        )}

        {!loading && cartItems.length === 0 && !error ? (
          <div className="empty-cart">
            <div className="empty-cart-icon">🛒</div>
            <h2 className="empty-cart-title">Your cart is empty</h2>
            <p className="empty-cart-message">
              Looks like you haven't added any items to your cart yet.
            </p>
            <button
              className="continue-shopping-btn"
              onClick={handleContinueShopping}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          cartItems.length > 0 && (
            <>
              {/* Selection Header */}
              <div className="cart-selection-header">
                <div className="select-all-container">
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={handleSelectAll}
                      className="select-all-checkbox"
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span className="select-all-text">
                    Select All ({cartItems.length} items)
                  </span>
                </div>
                {someSelected && (
                  <div className="selected-info">
                    {selectedCount} item(s) selected •{" "}
                    {formatCurrency(selectedTotal)}
                  </div>
                )}
              </div>

              <div className="cart-items-list">
                {cartItems.map((item) => (
                  <div key={item.cart_item_id} className="cart-item">
                    {/* Selection Checkbox */}
                    <div className="cart-item-select">
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={selectedItems[item.cart_item_id] || false}
                          onChange={() => handleSelectItem(item.cart_item_id)}
                          className="item-checkbox"
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>

                    <div className="cart-item-image">
                      <img
                        src={item.image || "/api/placeholder/200/200"}
                        alt={item.product_name}
                        onError={(e) => {
                          e.target.src = "/api/placeholder/200/200";
                        }}
                      />
                    </div>

                    <div className="cart-item-details">
                      <div className="cart-item-header">
                        <h3 className="cart-item-name">{item.product_name}</h3>
                        <button
                          className="cart-item-remove"
                          onClick={() => removeItem(item)}
                          disabled={updatingItem === item.cart_item_id}
                        >
                          <MdDeleteForever />
                        </button>
                      </div>

                      <div className="cart-item-specs">
                        {item.category && (
                          <span className="cart-item-spec">
                            {item.category}
                          </span>
                        )}
                        {item.size && (
                          <span className="cart-item-spec">
                            Size: {item.size}
                          </span>
                        )}
                        {item.wood_type && (
                          <span className="cart-item-spec">
                            Wood: {item.wood_type}
                          </span>
                        )}
                      </div>

                      <div className="cart-item-footer">
                        <div className="cart-item-price">
                          <span className="unit-price">
                            {formatCurrency(item.unit_price)}
                          </span>
                          <span className="total-price">
                            {formatCurrency(item.total_price)}
                          </span>
                        </div>

                        <div className="cart-item-quantity">
                          <button
                            className="quantity-btn"
                            onClick={() =>
                              handleQuantityChange(
                                item.cart_item_id,
                                (tempQuantities[item.cart_item_id] ||
                                  item.quantity) - 1,
                              )
                            }
                            disabled={
                              updatingItem === item.cart_item_id ||
                              (tempQuantities[item.cart_item_id] ||
                                item.quantity) <= 1
                            }
                          >
                            −
                          </button>

                          <span className="quantity-value">
                            {tempQuantities[item.cart_item_id] || item.quantity}
                          </span>

                          <button
                            className="quantity-btn"
                            onClick={() =>
                              handleQuantityChange(
                                item.cart_item_id,
                                (tempQuantities[item.cart_item_id] ||
                                  item.quantity) + 1,
                              )
                            }
                            disabled={updatingItem === item.cart_item_id}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      {tempQuantities[item.cart_item_id] !== item.quantity && (
                        <div className="cart-item-update">
                          <button
                            className="update-btn"
                            onClick={() =>
                              showUpdateConfirmation(
                                item,
                                tempQuantities[item.cart_item_id],
                              )
                            }
                            disabled={updatingItem === item.cart_item_id}
                          >
                            {updatingItem === item.cart_item_id
                              ? "Updating..."
                              : "Update Quantity"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-summary">
                <h2 className="summary-title">Order Summary</h2>

                {/* Cart Total */}
                <div className="summary-row">
                  <span>Subtotal ({cartSummary.total_items} items)</span>
                  <span>{formatCurrency(cartSummary.total_price)}</span>
                </div>

                {/* Selected Items Total */}
                {someSelected && (
                  <div className="summary-row selected-highlight">
                    <span>Selected Items ({selectedCount})</span>
                    <span>{formatCurrency(selectedTotal)}</span>
                  </div>
                )}

                <div className="summary-row total">
                  <span>Total</span>
                  <span>{formatCurrency(cartSummary.total_price)}</span>
                </div>

                {/* Checkout Button */}
                <button
                  className="checkout-btn"
                  onClick={handleCheckout}
                  disabled={!someSelected}
                >
                  Proceed to Checkout ({selectedCount} items)
                </button>

                <button
                  className="continue-shopping-link"
                  onClick={handleContinueShopping}
                >
                  ← Continue Shopping
                </button>
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};

export default EcomCart;
